import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { TransactionFlowType } from '../enums/transaction-flow-type.enum';
import { TransactionProduct, TransactionReceipt } from '../models';

export class TransactionState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public products: TransactionProduct[];
  public transactionId: number | null;
  public transactionReceipt: TransactionReceipt;
  public isDeletingInProgress: boolean;
  public transactionFlowType: TransactionFlowType;
  public wordOfTheDay: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.products = new Array<TransactionProduct>();
    this.transactionId = null;
    this.transactionReceipt = null;
    this.isDeletingInProgress = false;
    this.transactionFlowType = null;
    this.wordOfTheDay = null;
  }
}
